<template>
  <div>
    <a-row>
      <a-col :span="12">
        <a-descriptions
          title="基本信息"
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="名称">
            {{ esimSupplier.name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人">
            {{ esimSupplier.contact_name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人电话">
            {{ esimSupplier.contact_phone }}
          </a-descriptions-item>

          <a-descriptions-item label="eSIM总量">
            {{ esimSupplier.esim_total_count }}
          </a-descriptions-item>

          <a-descriptions-item label="库存量">
            {{ esimSupplier.esim_stock_count }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            {{ esimSupplier.remark }}
          </a-descriptions-item>

          <a-descriptions-item label="创建时间">
            {{ esimSupplier.created_at }}
          </a-descriptions-item>

          <a-descriptions-item label="更新时间">
            {{ esimSupplier.updated_at }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions
          title="登录信息"
          :column="1"
          class="simiot-descriptions simiot-descriptions-max-7"
        >
          <a-descriptions-item label="eSIM平台URL">
            <a :href="esimSupplier.platform_url" target="_blank">
              {{ esimSupplier.platform_url }}
            </a>
          </a-descriptions-item>

          <a-descriptions-item label="eSIM平台账号">
            {{ esimSupplier.platform_account }}
          </a-descriptions-item>

          <a-descriptions-item label="eSIM平台密码">
            {{ esimSupplier.platform_password }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findEsimSupplier } from '@/api/esim_supplier'

export default {
  name: 'ShowEsimSupplier',
  data() {
    return {
      esimSupplier: {}
    }
  },
  computed: {
    esimSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findEsimSupplier(this.esimSupplierId).then((res) => {
        if (res.code === 0) {
          this.esimSupplier = res.data
        }
      })
    }
  }
}
</script>
